function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

const AccessContext = require('./contexts/access-context');

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

const {
  strinct
} = require('../utils/serialize');

const linkFields = ['imageRefId', 'propertyId', 'businessId', 'locationId', 'offerId', 'keywords'];
const imgRefUrlField = 'imageRef.url';
/*:: type ImageLink = Object;*/

const buildPath = context => {
  const {
    propertyId,
    businessId,
    locationId
  } = context.serialize();
  const propertyFragment = `/properties/${propertyId}`;
  const businessFragment = `${businessId ? `/businesses/${businessId}` : ''}`;
  const locationFragment = `${locationId ? `/locations/${locationId}` : ''}`;
  return `${propertyFragment}${businessFragment}${locationFragment}`;
};

class ImageLinkRepo {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  , imageRefId
  /*: string*/
  ) {
    this.client = client;
    this.context = context;
    this.imageRefId = imageRefId;
  }

  details()
  /*: Promise<ImageLink>*/
  {
    const url = `${buildPath(this.context)}/imageRefs/${this.imageRefId}/index`;
    const req = new this.client.Request(url, {}, [...linkFields, imgRefUrlField]);
    return this.client.get(req);
  }

  update({
    /*: { keywords: [string] }*/

    keywords
  } = {})
  /*: Promise<ImageLink>*/
  {
    const url = `${buildPath(this.context)}/imageRefs/${this.imageRefId}/index`;
    const args = {};
    args.keywords = keywords;
    const req = new this.client.Request(url, args, ['imageRefId']);
    return this.client.patch(req);
  }

  unlink()
  /*: Promise<boolean>*/
  {
    const _this = this;

    return _call(function () {
      const url = `${buildPath(_this.context)}/imageRefs/${_this.imageRefId}/index`;
      const req = new _this.client.Request(url, {});
      return _await(_this.client.delete(req), function () {
        return true;
      });
    });
  }

}

class ImageLinksRepo {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.context = context;

    this.for = imageRefId => new ImageLinkRepo(client, context, imageRefId);

    this.icanhas = this.for;
  }

  link(imageRefId
  /*: string*/
  , {
    /*: { keywords: [string] }*/

    keywords = []
  } = {})
  /*: Promise<ImageLink>*/
  {
    const _this2 = this;

    return _call(function () {
      const {
        propertyId,
        businessId
      } = _this2.context.serialize();

      const payload = {
        propertyId,
        businessId,
        perms: ['property.business.mediaIndex.update']
      };
      const permUrl = `/self/accesses/check`;
      const permReq = new _this2.client.Request(permUrl, payload);
      return _await(_this2.client.post(permReq), function (hasPermission) {
        if (!hasPermission.granted) return null;
        const url = `${buildPath(_this2.context)}/imageRefs/${imageRefId}/index`;
        const req = new _this2.client.Request(url, {
          keywords
        }, linkFields);
        return _this2.client.post(req);
      });
    });
  }

  search(query
  /*: ?String*/
  , imageType
  /*: ?String*/
  )
  /*: Promise<ImageLink>*/
  {
    const url = `${buildPath(this.context)}/imageRefs/index/search`;
    const req = new this.client.Request(url, {
      q: strinct(query),
      imageType
    }, [...linkFields, imgRefUrlField]);
    return this.client.get(req);
  }

}

module.exports = ImageLinksRepo;